import { useEffect, useMemo, useState } from 'react';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import { useProduto } from '../../../contexts/produtos/ProdutoContext';
import './ModalOrdemProduto.css';

const parseOrderNum = (value) => {
    if (value === '' || value === null || value === undefined) {
        return null;
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

const ModalOrdemProduto = ({
    show,
    onHide,
    produtoSelecionado,
    onProdutoAtualizado,
}) => {
    const { produtos, updateProdutoOrderNum } = useProduto();
    const [updatingIds, setUpdatingIds] = useState([]);

    useEffect(() => {
        if (!show) {
            setUpdatingIds([]);
        }
    }, [show]);

    const grupoId = produtoSelecionado?.grupo?.id;

    const produtosDoGrupo = useMemo(() => {
        if (!grupoId) {
            return [];
        }

        return [...produtos]
            .filter((item) => item.grupo?.id === grupoId)
            .sort((a, b) => {
                const orderA = parseOrderNum(a.orderNum);
                const orderB = parseOrderNum(b.orderNum);

                if (orderA === null && orderB === null) {
                    return a.id - b.id;
                }

                if (orderA === null) {
                    return 1;
                }

                if (orderB === null) {
                    return -1;
                }

                if (orderA !== orderB) {
                    return orderA - orderB;
                }

                return a.id - b.id;
            });
    }, [grupoId, produtos]);

    const grupoDescricao = useMemo(() => {
        if (!grupoId) {
            return '';
        }

        if (produtoSelecionado?.grupo?.descricao) {
            return produtoSelecionado.grupo.descricao;
        }

        const produtoDoGrupo = produtos.find((item) => item.grupo?.id === grupoId && item.grupo?.descricao);
        return produtoDoGrupo?.grupo?.descricao || '';
    }, [grupoId, produtoSelecionado, produtos]);

    const handleChangeOrder = async (produto, delta) => {
        const currentOrder = parseOrderNum(produto.orderNum);
        const baseOrder = currentOrder === null ? 0 : currentOrder;
        const nextOrder = baseOrder + delta;

        if (nextOrder < 0 || updatingIds.includes(produto.id)) {
            return;
        }

        setUpdatingIds((prev) => [...prev, produto.id]);

        try {
            const produtoAtualizado = await updateProdutoOrderNum(produto.id, nextOrder);

            if (produtoAtualizado && produtoSelecionado?.id === produto.id && onProdutoAtualizado) {
                onProdutoAtualizado(produtoAtualizado);
            }
        } finally {
            setUpdatingIds((prev) => prev.filter((id) => id !== produto.id));
        }
    };

    return (
        <ModalContainer show={show} largura="600px" zIndex={1070}>
            <ModalHeader>
                <h5 className="modal-title">Ordenar Produtos</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
            </ModalHeader>
            <ModalBody>
                <div className="mb-3" style={{ color: '#000' }}>
                    <strong>Grupo:</strong> {grupoDescricao || 'Nao informado'}
                </div>

                <div className="table-responsive">
                    <table className="table table-bordered table-sm align-middle">
                        <thead>
                            <tr>
                                <th style={{ width: '60px', textAlign:'right' }}>Id</th>
                                <th>Descricao</th>
                                <th style={{ width: '120px' }}>OrdemNum</th>
                            </tr>
                        </thead>
                        <tbody>
                            {produtosDoGrupo.length === 0 && (
                                <tr>
                                    <td colSpan="3" className="text-center">
                                        Nenhum produto encontrado para este grupo.
                                    </td>
                                </tr>
                            )}

                            {produtosDoGrupo.map((produto) => {
                                const orderNum = parseOrderNum(produto.orderNum);
                                const isUpdating = updatingIds.includes(produto.id);
                                const disableUp = isUpdating || orderNum === null || orderNum <= 0;

                                return (
                                    <tr key={produto.id}>
                                        <td style={{textAlign:'right'}}>{produto.id}</td>
                                        <td>{produto.descricao}</td>
                                        <td>
                                            <div className="ordem-produto-actions">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() => handleChangeOrder(produto, -1)}                                                    
                                                    disabled={disableUp}
                                                    title="Aumentar ordem"
                                                >
                                                    -
                                                </button>
                                                <span className="ordem-produto-valor">
                                                    {orderNum === null ? '' : orderNum}
                                                </span>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() => handleChangeOrder(produto, +1)}
                                                    disabled={isUpdating}
                                                    title="Diminuir ordem"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary" onClick={onHide}>
                    Fechar
                </button>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ModalOrdemProduto;
